import { Storage } from "@/services/storage-services";
import {
  ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
  MERCHANT_SELECTED,
  REQUEST_LOGIN,
} from "./types";

export const initialState = {
  user: Storage.getItem("user") ? Storage.getItem("user") : {},
  loading: false,
  errorMessage: "",
  token: Storage.getItem("TreasuraAdminUserToken"),
  merchant: Storage.getItem("selectedMerchant")
    ? Storage.getItem("selectedMerchant")
    : {},
  teams: Storage.getItem("teams") ? Storage.getItem("teams") : [],
  businessId: Storage.getItem("businessId"),
};

export const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_LOGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: Storage.getItem("user"),
        token: Storage.getItem("TreasuraAdminUserToken"),
        teams: Storage.getItem("teams"),
        merchant: Storage.getItem("selectedMerchant"),
      };
    case MERCHANT_SELECTED:
      return {
        ...state,
        merchant: Storage.getItem("selectedMerchant"),
        businessId: Storage.getItem("businessId"),
      };
    case LOGOUT:
      return {
        ...state,
        user: {},
        token: "",
        merchant: {},
        teams: [],
        businessId: "",
      };
    case ERROR:
      return {
        ...state,
        errorMessage: action.payload,
      };
    default:
      return {
        initialState,
      };
  }
};
